export enum UserRole {
  SystemAdmin = 'SYSTEM_ADMIN',
  UserAdmin = 'USER_ADMIN',
  Editor = 'EDITOR',
  Unauthorized = 'UNAUTHORIZED',
  Guest = 'GUEST',
}

export type UserRoleMap = Partial<Record<UserRole, boolean>>;
